type Props = {
  rows?: number
  variant?: 'stats' | 'table' | 'card'
}

export default function AdminSkeleton({ rows = 4, variant = 'card' }: Props) {
  if (variant === 'stats') {
    return (
      <div className="vc-admin-stats">
        {Array.from({ length: rows }).map((_, index) => (
          <div key={index} className="vc-admin-skeleton vc-admin-skeleton--stat" />
        ))}
      </div>
    )
  }
  if (variant === 'table') {
    return (
      <div className="vc-admin-skeleton-table">
        {Array.from({ length: rows }).map((_, index) => (
          <div key={index} className="vc-admin-skeleton vc-admin-skeleton--row" />
        ))}
      </div>
    )
  }
  return (
    <div className="vc-admin-skeleton-stack">
      {Array.from({ length: rows }).map((_, index) => (
        <div key={index} className="vc-admin-skeleton vc-admin-skeleton--card" />
      ))}
    </div>
  )
}
